import Table16 from '@carbon/icons-react/es/table/16';
import { Tooltip } from 'antd';
import React, { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import { Button } from 'components/atoms/button';
import { IconWrapper } from 'components/atoms/icon-shell/icon-shell';
import { Modal } from 'components/atoms/modal';
import { ModalTitle } from 'components/atoms/modal/title';
import { DropdownMenu, DropdownMenuProps } from './grid-column-menu';

const StyledModal = styled(Modal)`
  width: 624px !important;
  .ant-modal-body {
    border-top: 1px solid var(--border-color);
    padding: 0;
  }
`;

export const ColumnListPopover: React.FC<DropdownMenuProps> = (props) => {
  const [showModal, setShowModal] = useState(false);

  return (
    <>
      <Tooltip
        title={<FormattedMessage id="projects.list.settings.edit" />}
        placement="top"
      >
        <Button
          icon={
            <IconWrapper>
              <Table16 style={{ transform: 'rotate(90deg)' }} />
            </IconWrapper>
          }
          type="text"
          size="small"
          data-cy="columns_reorder.dropdown.trigger"
          onClick={() => setShowModal(true)}
        />
      </Tooltip>
      <StyledModal
        visible={showModal}
        footer={null}
        closable={false}
        destroyOnClose
        onCancel={() => setShowModal(false)}
        maskClosable
        title={
          <ModalTitle
            primaryTitle={<FormattedMessage id="ag_grid.edit_columns" />}
            secondaryTitle={
              <FormattedMessage id="ag_grid.edit_columns.description" />
            }
          />
        }
      >
        <DropdownMenu {...props} onClose={() => setShowModal(false)} />
      </StyledModal>
    </>
  );
};
